/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_Summary_TitleInputs */

const en_pwf_summary_title = /** @type {(inputs: Pwf_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to switch`)
};

const de_pwf_summary_title = /** @type {(inputs: Pwf_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit zum Wechsel`)
};

/**
* | output |
* | --- |
* | "Ready to switch" |
*
* @param {Pwf_Summary_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_summary_title = /** @type {((inputs?: Pwf_Summary_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_Summary_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_summary_title(inputs)
	return en_pwf_summary_title(inputs)
});